import { ProjectType } from '../types/project-type.type';
import { SurveyStatus } from '../types/survey-status.type';

export const PROJECT_TYPE = {
  MCQB: 222,
  TRACKER: 444,
  GROUPED: 555,
} as const satisfies Record<string, ProjectType>;

export const SURVEY_STATUS = {
  DRAFT: 11,
  SCHEDULED: 12,
  LIVE: 22,
  PAUSED: 33,
  CLOSED: 44,
  INVOICED: 55,
} as const satisfies Record<
  'DRAFT' | 'SCHEDULED' | 'LIVE' | 'PAUSED' | 'CLOSED' | 'INVOICED',
  SurveyStatus
>;

export const SURVEY_STATUS_LABELS: Record<SurveyStatus, string> = {
  11: 'Draft',
  12: 'Scheduled',
  22: 'Live',
  33: 'Paused',
  44: 'Closed',
  55: 'Invoiced',
} as const;

export const STATUS_CONDITIONS: Array<{
  value: SurveyStatus;
  condition: SurveyStatus[];
}> = [
  { value: SURVEY_STATUS.LIVE, condition: [SURVEY_STATUS.PAUSED] },
  { value: SURVEY_STATUS.PAUSED, condition: [SURVEY_STATUS.LIVE] },
  {
    value: SURVEY_STATUS.CLOSED,
    condition: [SURVEY_STATUS.PAUSED, SURVEY_STATUS.LIVE],
  },
  { value: SURVEY_STATUS.INVOICED, condition: [SURVEY_STATUS.CLOSED] },
];

export const SURVEY_SCORE_THRESHOLDS = {
  DANGER_MAX: 49,
  WARNING_MAX: 74,
  SUCCESS_MAX: 100,
} as const;

export const SURVEY_HIGH_CPI_THRESHOLD = 10;

export const TWO_DECIMAL_PRECISION_REGEX_PATTERN = /^\d+(\.\d{0,2})?$/;

export const SURVEY_VALIDATION_ERROR = {
  HIGH_CPI:
    'Please confirm the Override CPI value you have entered is accurate.',
};

export const SURVEY_MARGIN_THRESHOLDS = {
  MIN: -99,
  MAX: 99,
} as const;
